import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';
import { slidesBotApi } from '../../api/slidesBot';
import { PanelCard, useFetchOnce } from './index';

interface Props {
  isDark: boolean;
}

export default function TopicsView({ isDark }: Props) {
  const { data, loading, error } = useFetchOnce(() =>
    slidesBotApi.topTopics(50),
  );

  return (
    <PanelCard isDark={isDark}>
      <div className="mb-4">
        <h2 className={cn('text-lg font-semibold', isDark ? 'text-white' : 'text-[#0F172A]')}>
          Top topics (completed jobs)
        </h2>
        <p className="text-xs text-slate-500 mt-1">
          Helps decide which subject-area templates to ship next.
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center py-8">
          <Loader2 className="w-6 h-6 animate-spin text-[#0EA5A4]" />
        </div>
      ) : error ? (
        <p className="text-red-500">Failed to load: {error}</p>
      ) : !data || data.length === 0 ? (
        <p className={cn('py-8 text-center', isDark ? 'text-slate-500' : 'text-slate-400')}>
          No completed jobs yet
        </p>
      ) : (
        <ol className="space-y-1">
          {data.map((row, i) => (
            <li
              key={i}
              className="flex items-center justify-between py-1.5 px-2 rounded hover:bg-slate-800/30"
            >
              <span className="text-sm">
                <span className="text-slate-500 mr-2 font-mono">
                  {String(i + 1).padStart(2, '0')}.
                </span>
                {row.topic}
              </span>
              <span className="font-mono text-sm text-[#0EA5A4]">
                ×{row.count}
              </span>
            </li>
          ))}
        </ol>
      )}
    </PanelCard>
  );
}
